const typographyFormActions = {
  true: 'Generar nueva acción',
  false: 'Editar acción',
  file: 'ADJUNTAR ARCHIVOS'
};

export default typographyFormActions;
